import { jsx as _jsx } from "react/jsx-runtime";
var Refresh = function Refresh(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      d: "M20.303 13.4258C19.777 13.2588 19.215 13.5498 19.047 14.0758C18.11 17.0218 15.352 18.9998 12.184 18.9998C8.222 18.9998 5 15.8598 5 11.9998C5 8.14076 8.222 4.99976 12.184 4.99976C13.912 4.99976 15.542 5.60176 16.829 6.66976L14.663 6.31276C14.113 6.21276 13.603 6.59176 13.513 7.13576C13.423 7.68076 13.792 8.19576 14.337 8.28476L18.583 8.98676C18.638 8.99576 18.694 8.99976 18.747 8.99976C18.866 8.99976 18.982 8.97876 19.09 8.93876C19.127 8.92476 19.157 8.89876 19.193 8.87976C19.259 8.84576 19.328 8.81576 19.385 8.76776C19.421 8.73876 19.444 8.69676 19.475 8.66276C19.522 8.61376 19.572 8.56676 19.607 8.50676C19.632 8.46376 19.642 8.41276 19.661 8.36476C19.685 8.30576 19.717 8.25076 19.729 8.18576L20.483 4.18576C20.585 3.64276 20.228 3.11876 19.685 3.01776C19.144 2.91976 18.619 3.27276 18.517 3.81476L18.245 5.25576C16.581 3.81476 14.448 2.99976 12.184 2.99976C7.12 2.99976 3 7.03676 3 11.9998C3 16.9628 7.12 20.9998 12.184 20.9998C16.226 20.9998 19.75 18.4608 20.953 14.6818C21.12 14.1558 20.829 13.5938 20.303 13.4258Z",
      fill: color
    })
  });
};
export default Refresh;